(function(){
  angular.module('edxComponents')
    .component('edxCreateNweaAssignmentLink', {
      templateUrl: '/resources/components/assign-focus/create-nwea-assignment/create-nwea-assignment-link.component.html',
      controller: ['navigation', CreateNweaAssignmentLinkController],
      controllerAs: 'vm',
      bindings: {}
    });

  function CreateNweaAssignmentLinkController(navigation) {
    var vm = this;
    vm.onClick = onClick;

    function onClick() {
      navigation.go('.', {
        'assign': 'true',
        'pane': 'create_nwea_assignment'
      });
    }
  }
})();
